__turbopack_context__.v({
  "darkModeButton": "OAuthButtons-module__0lP7lW__darkModeButton",
  "errorMessage": "OAuthButtons-module__0lP7lW__errorMessage",
  "facebookSigninButton": "OAuthButtons-module__0lP7lW__facebookSigninButton",
  "facebookSigninIcon": "OAuthButtons-module__0lP7lW__facebookSigninIcon",
  "googleSigninButton": "OAuthButtons-module__0lP7lW__googleSigninButton",
  "googleSigninIcon": "OAuthButtons-module__0lP7lW__googleSigninIcon",
  "lightModeButton": "OAuthButtons-module__0lP7lW__lightModeButton",
  "oauthButtonContainer": "OAuthButtons-module__0lP7lW__oauthButtonContainer",
  "oauthDivider": "OAuthButtons-module__0lP7lW__oauthDivider",
  "oauthDividerLine": "OAuthButtons-module__0lP7lW__oauthDividerLine",
  "oauthDividerText": "OAuthButtons-module__0lP7lW__oauthDividerText",
});
